<script>
export default {
  props: {
    opcoesDropdown: {
      type: Array,
      default: () => [
        { text: 'Ação 1', action: () => alert('Ação 1 clicada'), title: 'teste' },
        { text: 'Ação 2', disabled: true, icon: 'el-icon-plus', visible: false },
        { text: 'Ação 3', divided: true, action: () => alert('Ação 3 clicada') }
      ]
    },
    modeDropdown: {
      type: String,
      default: 'List',
      validator: value => ['List', 'Custom'].includes(value)
    }
  },
  methods: {
    handleClick (option) {
      if (typeof option.action === 'function') {
        option.action()
      }
    }
  }
}
</script>

<template>
  <el-dropdown @command="handleClick">
    <slot name="dropdown-trigger" class="el-dropdown-link"></slot>
    <el-dropdown-menu slot="dropdown">
      <div v-if="modeDropdown === 'List'">
        <el-dropdown-item
          v-for="(option, index) in opcoesDropdown"
          :key="index"
          :command="option"
          :disabled="option.disabled"
          :divided="option.divided"
          :icon="option.icon"
          v-show="option.visible !== false"
        >
          {{ option.text }}
        </el-dropdown-item>
      </div>
      <div v-else>
        <slot name="custom-content" />
      </div>
    </el-dropdown-menu>
  </el-dropdown>
</template>



// WEBPACK FOOTER //
// src/components(new)/UI/Dropdowns/BaseDropdown/BaseDropdown.vue